import React from 'react';
import useENotification from '../../../../../hooks/eNotification';

const path = '../oldPages/e-notification/other-template/index.html';

function ENotificationOtherTemplate() {
  const { iframeRef } = useENotification();

  return <iframe ref={iframeRef} title="e-notification-other-template" src={path} width="100%" height="500px" />;
}

export default ENotificationOtherTemplate;
